import { useMutation, useQueryClient } from "@tanstack/react-query";

import { PROMOTION_CACHE_KEYS } from "./keys";

import { PromotionRepository } from "@/repositories/promotion";
import { UpdatePromotion } from "@/types";

const promotionRepository = new PromotionRepository();

export const useUpdatePromotion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdatePromotion }) =>
      promotionRepository.update(id, data),
    onSuccess: (promotion) => {
      queryClient.setQueryData(
        PROMOTION_CACHE_KEYS.DETAIL(promotion.id),
        promotion,
      );
      queryClient.invalidateQueries({ queryKey: PROMOTION_CACHE_KEYS.LISTS });
    },
  });
};
